/** @jsx dom */
import {Cell, Grid} from 'viskan-deku-grid';
import deepEqual from 'deep-equal';
import dom from 'magic-virtual-element';
import Link from '../../link';
import {Discount, Row, Summary} from '../';
import ShopcartOffers from './offers';

const propTypes = {
	openPopup: {
		source: 'openPopup'
	}
};

const getRows = data => data.map(x => <Row key={x.row_id} data={x}/>);

const shouldUpdate = ({props}, nextProps) => !deepEqual(props, nextProps);

const render = ({props}) => {
	const {getTranslation, shopcart} = props;
	const {rows, offers} = shopcart;
	const onClick = () => props.openPopup((
		<div class='discount-popup'>
			<Discount/>
		</div>
	), {
		class: 'DiscountPopup',
		height: 'auto',
		width: 'auto'
	});

	return (
		<div class='Shopcart'>
			<div class='Shopcart-deductions Shopcart-footer-space'>
				<h2 class='Heading'>
					{getTranslation('shopcart.label')}
				</h2>
			</div>
			<div class='Shopcart-rowColumns'>
				<div class='Shopcart-rowColumn-article'><noscript/></div>
				<div class='Shopcart-rowColumn-quantity'>{getTranslation('global.quantity')}</div>
				<div class='Shopcart-rowColumn-price'>{getTranslation('global.price')}</div>
				<div class='Shopcart-rowColumn-impact'/>
			</div>
			<div class='Shopcart-rows'>
				{Boolean(rows.length) && getRows(rows)}
			</div>
			<div class='Shopcart-global'>
				<Grid>
					<Cell md-size='7of12' sm-size='full'>
						<div class='Shopcart-deductions-title'>
							<Link class='Shopcart-deductions-link' onClick={onClick}>{getTranslation('checkout.offercode')}</Link>
						</div>
					</Cell>
					<Cell md-size='5of12' sm-size='full'>
						<div class='ShopcartSummary'>
							<ShopcartOffers data={offers.head}/>
							<Summary data={shopcart}/>
						</div>
					</Cell>
				</Grid>
			</div>
		</div>
	);
};

export default {propTypes, render, shouldUpdate};
